export default {
  apiKey: "AIzaSyABOm4-3LpvlZFSPCJbnVHVSWTIDatjLEs",
  authDomain: "tm-geodata-warehouse.firebaseapp.com",
  databaseURL: "https://tm-geodata-warehouse.firebaseio.com",
  projectId: "tm-geodata-warehouse",
  storageBucket: "tm-geodata-warehouse.appspot.com",
  messagingSenderId: "175939480314",
  appId: "1:175939480314:web:0f12dc3cf32f06bfa4b743",
};
